<template>
  <v-card flat height="calc(100vh - 106px)" class="overflow-y pt-4 pl-4">
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="10" md="8">
          <v-card flat outlined>
            <v-container>
              <v-row class="mb-1">
                <v-col class="text-body-2">
                  Specify the mapping of PŪRTRAK sites to Square locations in order to properly track inventory.
                  (Square products/variants must have their stock locations set in Square.)
                </v-col>
              </v-row>
              <v-row v-for="location of square.locationMap" :key="location.siteId">
                <v-col cols="12" sm="6"><v-text-field readonly outlined dense hide-details :value="location.siteName" label="PŪRTRAK site"/></v-col>
                <v-col cols="12" sm="6">
                  <v-select :items="[{id:null,name:'no mapping'},{divider:true},...square.locations]" v-model="location.locationId" item-text="name" item-value="id"
                        label="Square location" outlined dense hide-details @change="setLocation(location)"/>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="mt-6">
        <v-col col="12" sm="6">Square inventory can be automically updated from PURTRAK on a regular basis</v-col>
        <v-col cols="6" sm="2">
          <v-select label="Update frequency" v-model="square.settings.inventoryUpdateFrequency" :items="['Never','Daily','Hourly']"
                    dense outlined hide-details @change="$emit('saveSettings')"/>
        </v-col>
      </v-row>
      <v-row class="mt-6">
        <v-col>
          <v-btn @click="setInventory" color="primary" :loading="loading">Update inventory now</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: 'AppsSquareProducts',
  props: {
    square: {type:Object, required:false}
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    async setLocation(location) {
      this.loading = true;
      await this.$apiCall(`mutation AppsSquareInventory($input: SquareLocationMappingInput!) {
                                squareSetLocation(input:$input) {locationId}
                              }`,
                          {input:{siteId:location.siteId,locationId:location.locationId}}, false, 'square');
      this.loading = false;
    },
    async setInventory() {
      this.loading = true;
      const results = await this.$apiCall(`mutation AppsSquareInventory {
                                            squareSetInventory
                                          }`,
                                          {}, false, 'square');
      this.loading = false;
      if (!results.error)
        this.$store.commit('setError', {type:'success',message:`Square inventory updated`});
    }
  }
}
</script>